<template>
  <div>
    <template v-for="(component, index) in components" :key="index">
      <Container
        v-if="containerIndent && !fullWidthTypes.includes(component.type)"
        :indent="containerIndent"
      >
        <Component
          :is="getType(component)"
          v-editor-target="index"
          :data="component"
          :scroll-to-index="index"
          :index="index"
          :prev-component="components[index - 1]?.type"
          :next-component="components[index + 1]?.type"
        />
      </Container>

      <Component
        :is="getType(component)"
        v-else
        v-editor-target="index"
        :data="component"
        :scroll-to-index="index"
        :index="index"
        :prev-component="components[index - 1]?.type"
        :next-component="components[index + 1]?.type"
      />
    </template>
  </div>
</template>

<script setup>
defineProps({
  components: { type: Array, default: () => [] },
  // wraps each component in a container with this indent (e.g. 'center' for news articles)
  containerIndent: { type: String, default: null },
  // component types that are not wrapped in the container and span the full width
  fullWidthTypes: { type: Array, default: () => [] },
})

function getType(component) {
  if (!component.type) {
    console.error('ComponentLoader: Component has no type', component)
    return null
  }

  if (component.type === 'text') {
    return 'Bard'
  }

  return component.type.replaceAll(/_/g, '-')
}
</script>
